const globalConfig = require( "./config.all" );
module.exports = {
	...globalConfig,
	environment: "production",
	appBaseUrl: "https://app.teaming.com",
	auth0Audience: "https://meetingful.auth0.com/api/v2/",
	auth0Domain: "auth.teaming.com",
	auth0ClientId: "5ygKPeQEiekcvalZWWGQmee0wXGppyP6",
	baseUri: "https://api.teaming.com/api",
	crystalApiToken: "cefb5f8db67511cb9908ecc8bc954a57",
	coachingLink: "https://calendly.com/kate-oneil1/teaming-coaching-call",
	demoLink: "https://calendly.com/kate-oneil1/30-minute-meeting",
	// ZOOM OAUTH FEATURE FLAG
	enableZoomOauth: true,
	amplitudeToken: "15ecada3bef092a9a0d2d49e4dcd34bd",
	apiSocketEndpoint: "wss://socks.teaming.com",
	iceWebsocketUrl: "wss://ice.teaming.com",
	stripePaymentLink: "https://buy.stripe.com/28ocOr1Bm6U97E414j",
	zoomMeetingSdkClientId: "q7ZRhcwtTtxi_PZkAQLpA",
	zoomOauthRedirectUri: "https://app.teaming.com/t2/zoom-oauth-callback",
};
